var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, _vm._l(_vm.answers, function (answer, index) {
    return _c('Checkbox', {
      key: index,
      attrs: {
        "label": _vm.getLabel(answer.label, index),
        "checked": _vm.isChecked(answer.id),
        "id": answer.id,
        "onSelect": _vm.onSelect,
        "isCorrect": answer.correct,
        "isDisabled": _vm.isDisabled(answer.id),
        "isHinted": _vm.showHints && !_vm.isChecked(answer.id) && _vm.correctAnswers.includes(answer.id),
        "isSubmitted": _vm.hasBeenSubmitted,
        "numOfAttempts": _vm.numOfAttempts,
        "showError": _vm.showErrors,
        "showSuccess": _vm.showSuccess && _vm.lockedAnswers.includes(answer.id)
      }
    });
  }), 1);
}
var staticRenderFns = []

export { render, staticRenderFns }